function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { buildClassNames } from '../../../modules/css-helpers';
import { createOwnUpComponent } from '../../components';
import { OwnUpSectionStyle } from './style';
/**
 * Box component properties.
 */

var StyledComponent = createOwnUpComponent('div', OwnUpSectionStyle);
/**
 * An Own Up branded div. Changes background color depending on the
 *   variant type.
 *
 * @param props see {@link OwnUpSectionProps}
 */

export var OwnUpSection = function OwnUpSection(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  var classes = buildClassNames('ou-section', className);
  return /*#__PURE__*/React.createElement(StyledComponent, _extends({
    className: classes
  }, props));
};